var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.687 4.21298L4.8 16.976C4.89665 17.5603 5.19759 18.0913 5.6492 18.4744C6.10081 18.8575 6.67377 19.0679 7.266 19.068H10.614M17.312 4.21298L15.2 16.976C15.1033 17.5603 14.8024 18.0913 14.3508 18.4744C13.8992 18.8575 13.3262 19.0679 12.734 19.068H9.386M8.022 9.11598V14.165M11.978 9.11598V14.165M0.75 4.21298H19.25M12.777 4.21298V2.43298C12.777 2.03516 12.619 1.65363 12.3377 1.37232C12.0564 1.09102 11.6748 0.932983 11.277 0.932983H8.723C8.32517 0.932983 7.94364 1.09102 7.66234 1.37232C7.38104 1.65363 7.223 2.03516 7.223 2.43298V4.21298H12.777Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.705db172e2c95f25154fad29350111d6.svg";
export { ForwardRef as ReactComponent };